// extracted by mini-css-extract-plugin
export var Active = "footer-module--Active--970ab";
export var App = "footer-module--App--b3195";
export var Community = "footer-module--Community--16455";
export var Footer = "footer-module--Footer--f6f6d";
export var FooterFlex = "footer-module--FooterFlex--ded07";
export var Legal = "footer-module--Legal--ddf35";
export var Logo = "footer-module--Logo--d9340";
export var Menu = "footer-module--Menu--a3978";
export var MenuItem = "footer-module--MenuItem--238be";
export var Mobile = "footer-module--Mobile--d4dff";
export var Newsletter = "footer-module--Newsletter--9a01f";
export var NewsletterField = "footer-module--NewsletterField--bfc4c";
export var NewsletterForm = "footer-module--NewsletterForm--500ea";
export var Social = "footer-module--Social--8b049";
export var Stores = "footer-module--Stores--01c1a";
export var Tooltip_Text = "footer-module--Tooltip_Text--c0763";
export var Tootltip = "footer-module--Tootltip--f3513";
export var contact = "footer-module--contact--3b817";
export var error = "footer-module--error--20f97";